var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.417,
    height: 16.3,
    viewBox: "0 0 16.417 16.3",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "modifica_candidato",
    "data-name": "modifica candidato",
    transform: "translate(0.15 0.15)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icona_modifica_nominativo",
    "data-name": "icona modifica nominativo",
    transform: "translate(-368 -734)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_112",
    "data-name": "Tracciato 112",
    d: "M14.767,47.655a.4.4,0,0,0-.4.4v3.556a1.2,1.2,0,0,1-1.2,1.2H1.992a1.2,1.2,0,0,1-1.2-1.2V41.175a1.2,1.2,0,0,1,1.2-1.2H5.53a.4.4,0,0,0,0-.8H1.992a2,2,0,0,0-1.992,2V51.611a2,2,0,0,0,1.992,2H13.173a2,2,0,0,0,1.992-2V48.055a.4.4,0,0,0-.4-.4Zm0,0",
    transform: "translate(368 696.386)",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_113",
    "data-name": "Tracciato 113",
    d: "M118.887.789a1.787,1.787,0,0,0-2.536,0l-7.109,7.145a.4.4,0,0,0-.1.176L108.2,11.5a.4.4,0,0,0,.1.39.4.4,0,0,0,.388.1l3.375-.94a.4.4,0,0,0,.175-.1l7.109-7.145a1.811,1.811,0,0,0,0-2.549ZM110.11,8.194l5.818-5.848L117.8,4.232l-5.818,5.848Zm-.375.756,1.5,1.507-2.074.577Zm9.056-5.709-.423.425L116.492,1.78l.423-.425a.993.993,0,0,1,1.409,0l.468.47A1.006,1.006,0,0,1,118.791,3.241Zm0,0",
    transform: "translate(264.121 733.739)",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.3
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.fd5080e3db4311dc4b60a22aec8c42a3.svg";
export { ForwardRef as ReactComponent };